/**
 * @fileoverview gRPC-Web generated client stub for commonpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.commonpb = require('./systemcode_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.commonpb.SystemCodeServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.commonpb.SystemCodeServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.commonpb.LazySystemCodeRequest,
 *   !proto.commonpb.SystemCodeResponse>}
 */
const methodDescriptor_SystemCodeService_LazySystemCode = new grpc.web.MethodDescriptor(
  '/commonpb.SystemCodeService/LazySystemCode',
  grpc.web.MethodType.UNARY,
  proto.commonpb.LazySystemCodeRequest,
  proto.commonpb.SystemCodeResponse,
  /**
   * @param {!proto.commonpb.LazySystemCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.commonpb.SystemCodeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.commonpb.LazySystemCodeRequest,
 *   !proto.commonpb.SystemCodeResponse>}
 */
const methodInfo_SystemCodeService_LazySystemCode = new grpc.web.AbstractClientBase.MethodInfo(
  proto.commonpb.SystemCodeResponse,
  /**
   * @param {!proto.commonpb.LazySystemCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.commonpb.SystemCodeResponse.deserializeBinary
);


/**
 * @param {!proto.commonpb.LazySystemCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.commonpb.SystemCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.commonpb.SystemCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.commonpb.SystemCodeServiceClient.prototype.lazySystemCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/commonpb.SystemCodeService/LazySystemCode',
      request,
      metadata || {},
      methodDescriptor_SystemCodeService_LazySystemCode,
      callback);
};


/**
 * @param {!proto.commonpb.LazySystemCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.commonpb.SystemCodeResponse>}
 *     Promise that resolves to the response
 */
proto.commonpb.SystemCodeServicePromiseClient.prototype.lazySystemCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/commonpb.SystemCodeService/LazySystemCode',
      request,
      metadata || {},
      methodDescriptor_SystemCodeService_LazySystemCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.commonpb.ListSystemCodeRequest,
 *   !proto.commonpb.SystemCodeResponse>}
 */
const methodDescriptor_SystemCodeService_ListSystemCode = new grpc.web.MethodDescriptor(
  '/commonpb.SystemCodeService/ListSystemCode',
  grpc.web.MethodType.UNARY,
  proto.commonpb.ListSystemCodeRequest,
  proto.commonpb.SystemCodeResponse,
  /**
   * @param {!proto.commonpb.ListSystemCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.commonpb.SystemCodeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.commonpb.ListSystemCodeRequest,
 *   !proto.commonpb.SystemCodeResponse>}
 */
const methodInfo_SystemCodeService_ListSystemCode = new grpc.web.AbstractClientBase.MethodInfo(
  proto.commonpb.SystemCodeResponse,
  /**
   * @param {!proto.commonpb.ListSystemCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.commonpb.SystemCodeResponse.deserializeBinary
);


/**
 * @param {!proto.commonpb.ListSystemCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.commonpb.SystemCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.commonpb.SystemCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.commonpb.SystemCodeServiceClient.prototype.listSystemCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/commonpb.SystemCodeService/ListSystemCode',
      request,
      metadata || {},
      methodDescriptor_SystemCodeService_ListSystemCode,
      callback);
};


/**
 * @param {!proto.commonpb.ListSystemCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.commonpb.SystemCodeResponse>}
 *     Promise that resolves to the response
 */
proto.commonpb.SystemCodeServicePromiseClient.prototype.listSystemCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/commonpb.SystemCodeService/ListSystemCode',
      request,
      metadata || {},
      methodDescriptor_SystemCodeService_ListSystemCode);
};


module.exports = proto.commonpb;

